module.exports = __webpack_public_path__ + "img/s3-img1.9577ad9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s3-img1.jpg
// module id = 412
// module chunks = 0